/**  */

// eslint-disable-next-line
import React from 'react';
import { Container, Row, Col } from 'react-grid-system';
import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import { bp } from '../../config/breakpoints';

const HeroContent = ({ title, parentPage }) => {
  const cssTitle = css`
    font-size: 6rem;
    color: #fff;
    text-transform: uppercase;
    z-index: 50;
    line-height: 1;
    margin-top: 5%;

    @media (max-width: ${bp.mx_lg}) {
      font-size: 5rem;
    }

    @media (max-width: ${bp.mx_md}) {
      font-size: 3.6rem;
    }
  `;

  const cssBreadcrumb = css`
    color: #fff;
    font-size: 2.2rem;
    font-weight: 600;
    text-transform: capitalize;
  `;

  return (
    <Container>
      <Row>
        <Col>
          {parentPage && (
            <Link css={cssBreadcrumb} to={`/${parentPage}/`}>
              {parentPage} /
            </Link>
          )}
          <h1 css={cssTitle} dangerouslySetInnerHTML={{ __html: title }} />
        </Col>
      </Row>
    </Container>
  );
};

HeroContent.defaultProps = {
  parentPage: null,
};

HeroContent.propTypes = {
  title: PropTypes.string.isRequired,
  parentPage: PropTypes.string,
};

export default HeroContent;
